import { Dropbox } from './Dropbox';
export default Dropbox;